import React from "react";
import Loader from "./components/loader";
import PCCardRenderer from "./components/pc-card-renderer";
import CustomList from "components/list/custom";

const ProjectsCoordinating = () => {
  return (
    <div className="flex-1 h-full w-full">
      <CustomList
        storageKey="pc_timesheet_summary"
        endPoint="custom-ui/get-pc-timesheet-summary"
        hidePagination={true}
        showSearch={false}
        perPage={25}
        renderItems={PCCardRenderer}
        renderItemsLoader={Loader}
      />
    </div>
  );
};

export default ProjectsCoordinating;
